import { Button, Label, Radio, Spinner } from 'flowbite-react';
import React, { useState } from 'react';
import Select, { SingleValue } from 'react-select';
import { Dropdown } from 'shared-utils';
import { useToast } from 'src/context/ToastProvider';
import { useUserContext } from 'src/context/UserProvider';
import { useGetAllAccountManagers, useGetMyBDPocsQuery } from 'src/hooks/user.hooks';
import { LeadActionInput } from 'types';

interface Props {
	companyId: string;
	isLoading?: boolean;
	onSubmit: (data: LeadActionInput) => void;
	bdPOCName?: string;
	bdPOCId?: string;
	leadGen?: any;
}

const AMAssignBDPOC = ({ onSubmit, isLoading, companyId, bdPOCName, bdPOCId, leadGen }: Props) => {
	const toast = useToast();
	const { user } = useUserContext();

	const [assignedBDPoc, setAssignedBDPoc] = useState<string>(bdPOCId || "");
	const { data: myBDPOCsData } = useGetMyBDPocsQuery();

	const { data: accountManagersData, isLoading: accountManagersLoading } = useGetAllAccountManagers({
		isDefaultSecondaryPOC: true,
	});


	// const options = accountManagersData?.users?.map(am => ({ label: am.name, value: String(am._id) }));
	const options = myBDPOCsData?.bds?.map(am => ({ label: am.name, value: String(am._id) }));
	const userBDOption = options?.find(o => o.label === user?.name);
	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				try {
					// If BD POC is optional, remove it from the condition
					if (leadGen) {
						// Get latest leadGen
						const latestLeadGen = leadGen.sort((a: any, b: any) =>
							new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
						)[0];

						const shareData: LeadActionInput = {
							companyId,
							action: 'qualified',
							remarks: '',
							assignedBDPoc: assignedBDPoc || bdPOCId,
							leadGenPocId: latestLeadGen?.leadGen?.leadGenPOC?._id,
						};
						// Add validation to prevent form submission with missing BD POC
						if (!shareData.assignedBDPoc) {
							console.error("Missing required BD POC ID");
							toast({
								title: "Cannot qualify: BD POC information is missing",
								type: 'error',
							});
							return; 
						}

						onSubmit(shareData);
					} else {
						console.error("Missing leadGen data", { leadGen });
						toast({
							title: "Cannot qualify: Missing lead information",
							type: 'error',
						});
					}
				} catch (err) {
					console.log('err:', err);
					toast({
						title: `Something went wrong! ${err}`,
						type: 'error',
					});
				}
			}}
		>
			<div className="mb-4 block whiteBgSelect p-4 gap-4">
				<div className="mb-[4px]">
					<Label>{'Lead Status '}</Label>
					<span className="text-[red]">*</span>
				</div>

				<div className="flex items-center gap-2">
					<Radio
						className="text-[#7777E7] focus:ring-[#7777E7]"
						id={'qualified'}
						name="qualified"
						value={'Qualified'}
						checked
					/>
					<Label htmlFor={'Qualified'} className="text-sm font-[400] font-inter">
						Qualified
					</Label>
				</div>
			</div>

			{/* <div className="block min-h-[350px]">
				<div className="mb-[8px] flex justify-between items-end">
					<div>
						<Label>{'Assign BD POC'}</Label>
						<span className="text-red-500">*</span>
					</div>
				</div>
				<Select
					classNamePrefix="my-select-plans"
					isLoading={accountManagersLoading}
					closeMenuOnSelect
					options={options}
					defaultValue={userBDOption || (bdPOCName ? { label: bdPOCName, value: bdPOCId || "" } : null)} value={options?.find(o => o.value === assignedBDPoc)}
					onChange={(val: SingleValue<Dropdown>) => setAssignedBDPoc(val?.value || bdPOCId || "")}
				/>
			</div> */}

			<Button
				color="purplePlaced"
				type="submit"
				className="mt-[20px] mb-[20px] w-full bg-[#7777E7]"
				disabled={isLoading}
			>
				{isLoading ? <Spinner /> : 'Confirm'}
			</Button>
		</form>
	);
};

export default AMAssignBDPOC;
